<template>
    <div class="container mt-3 no-select" @contextmenu.prevent="preventRightClick">
      <div class="row">
        <div>
          Time left: {{ timerFormatted }}
        </div>
        <div class="col-md-12">
          <!-- Question Section with a light background -->
          <div class="mb-3 p-3">
            <p>{{ currentQuestion }}</p>
          </div>
          <!-- Code viewer div -->
          <div v-if="currentQuestionSourceCode" style="background-color: white; padding-left: 20px;">
            <code-viewer :code="currentQuestionSourceCode" :language="currentQuestionSourceCodeLanguage"></code-viewer>
          </div>  
          <!-- Answers Section with colored answer options -->
          <div v-for="(option, index) in currentAnswerChoices" :key="option.id" class="mb-2">
            <div class="input-group align-items-center ">
              <div class="input-group-prepend">
                <button class="input-group align-items-center w-100 btn"
                :class="{ 'selected': selectedAnswer === option }"
                @click="selectAnswer(option)">
                <div class="input-group-text" :class="`bg-option-${index + 1}`">
                  {{ option.letter }}
                </div>
                </button>
              </div>
              <!--<input type="text" class="form-control" :placeholder="'Answer ' + option.letter">-->
              <div class="m-3" style="flex-grow: 1;">
                {{ option.answer }}
             </div>
            </div>
          </div>
        </div>  
        <div class="col-md-4">
          <!-- Image Section with a darker border -->
          <div class="mb-3">
            <!--<label for="assessmentImage" class="form-label">Image</label>-->
            <div class="border border-secondary p-3" style="width: 100%; height: 200px; background-color: #f8f9fa;" v-if="currentQuestionImageURI">
              <!-- Placeholder for image -->
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row justify-content-end">
          <div class="col-1">
            <button type="submit" class="btn btn-primary submit-button" @click="continueAssessment">
              Next Question
            </button>
          </div>
        </div>
        </div>
        <div class="container">
          <div class="center">
            Question {{ currentQuestionNumber }} of {{ numberOfQuestions }}
          </div>
        </div>
      </div>
    </div>
    <DialogModal :error-message="noAnswerSelectedMessage" :error-title="noAnswerSelectedTitle" :info-class="noAnswerSelectedClass" ref="dialogModal" />
  </template>
  
  <script>
  import { getCookie } from '@/utils/cookies/cookieUtils';
  import { endpoint } from '@/utils/endpoint/endpointUtils';
  import DialogModal from '@/components/DialogModal.vue';
  import CodeViewer from '@/components/CandidateAssessment/AssessmentUI/CodeViewer.vue'


  export default {
    name: 'Question',
    components: {
      DialogModal,
      CodeViewer
    },
    emits: ['assessment-finish'],
    data() {
      return {
        currentQuestion: '',
        currentQuestionSourceCode: null,
        currentQuestionSourceCodeLanguage: null,
        currentAnswerChoices: {},
        selectedAnswer: null,
        currentAssessmentResultId: 0,
        currentQuestionImageURI: '',
        noAnswerSelectedTitle: 'Assessment',
        noAnswerSelectedMessage: 'You must select an answer to continue.',
        noAnswerSelectedClass: 'alert alert-warning',
        currentQuestionNumber: 1,
        numberOfQuestions: getCookie('numberOfQuestions'),
        timeLimit: 0,
        timedAssessment: false,
        timer: null,
        timerFormatted: ''
      }
    }, 
    methods: {
      selectAnswer(answer) {
        this.selectedAnswer = answer;
        console.log(this.selectedAnswer);
      },
      async sendAnswer() {
        var userid = getCookie('userid');
        var token = getCookie('token');
        
        var body = {
          assessmentResultId: this.currentAssessmentResultId,
          selectedAnswer: this.selectedAnswer.letter
        };

        try {
              const response = await fetch(endpoint + '/api/Assessments/AnswerQuestion', {
              method: 'POST',
              headers: {
                  'Authorization': 'Bearer ' + token,
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify(body),
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();
          console.log(data);

        } catch(error) {
          console.log(error);
        }
      },
      async getNextQuestion() {
        var userid = getCookie('userid');
        var assessmentId = getCookie('assessmentId');
        var token = getCookie('token');
        
        var body = {
          userId: userid,
          assessmentId: assessmentId
        };

        try {
              const response = await fetch(endpoint + '/api/Assessments/GetNextQuestion', {
              method: 'POST',
              headers: {
                  'Authorization': 'Bearer ' + token,
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify(body),
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();
          console.log(data);
          if (data.status !== 400) {
            this.currentQuestion = data.question.question;
            this.currentAnswerChoices = data.question.options;
            this.currentAssessmentResultId = data.question.assessmentResultId;
            if (data.question.sourceCode) {
              this.currentQuestionSourceCode = '\n' + data.question.sourceCode;
              this.currentQuestionSourceCodeLanguage = data.question.sourceCodeLanguage;
            } else {
              this.currentQuestionSourceCode = null;
              this.currentQuestionSourceCodeLanguage = null;
            }
          } else {
            // No questions, but not status 400
            // Score the assessment
            if (!data.question) {
              clearInterval(this.timer);
              await this.scoreAssessment();
            }
          }

        } catch(error) {
          console.log(error);
        }
      },
      async continueAssessment() {
          if (this.selectedAnswer) {
          // Send answer to back-end
          await this.sendAnswer();
          // Grab next question from back-end
          await this.getNextQuestion();
          // Set choice to null
          this.selectedAnswer = null;
          this.currentQuestionNumber++;
        } else {
          this.$refs.dialogModal.openModal();
        }
      },
      async scoreAssessment() {

        var body = {
          userId: getCookie('userid'),
          assessmentId: getCookie('assessmentId')
        };

        var token = getCookie('token');

        try {
              const response = await fetch(endpoint + '/api/Assessments/ScoreAssessment', {
              method: 'POST',
              headers: {
                  'Authorization': 'Bearer ' + token,
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify(body),
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();
          console.log(data);
          if (data.status === 200) {
            this.$emit('assessment-finish');
          }          

        } catch(error) {
          console.log(error);
        }        
      },
      formatTimeFromSeconds(totalSeconds) {
      // Calculate hours, minutes, and seconds
      let hours = Math.floor(totalSeconds / 3600);
      totalSeconds %= 3600;
      let minutesLeft = Math.floor(totalSeconds / 60);
      let seconds = totalSeconds % 60;

      // Pad the minutes and seconds with leading zeros if needed
      let paddedHours = String(hours).padStart(2, '0');
      let paddedMinutes = String(minutesLeft).padStart(2, '0');
      let paddedSeconds = String(seconds).padStart(2, '0');

      // Format the time in HH:MM:SS
      return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
      },
    },
    mounted() {
      this.getNextQuestion();
      this.timeLimit = parseInt(getCookie('limit'));
      if (this.timeLimit > 0) {
        this.timedAssessment = true;
        this.timer = setInterval(() => {
           this.timeLimit--;
           this.timerFormatted = this.formatTimeFromSeconds(this.timeLimit);

           if (this.timeLimit <= 0) {
            clearInterval(this.timer);
            this.scoreAssessment();
           }
        }, 1000); // every second decrease limit.
      }
    }
  }
  </script>
  
  <style scoped>
  /* Custom colors for options */
  .bg-option-1 { background-color: #e7f1ff; } /* Light blue */
  .bg-option-2 { background-color: #ffefe7; } /* Light orange */
  .bg-option-3 { background-color: #e7ffe8; } /* Light green */
  .bg-option-4 { background-color: #fff3e7; } /* Light yellow */
  .bg-option-5 { background-color: #f3e7ff; } /* Light purple */

  .submit-button {
  width: 300px;
  padding: 10px;
  background-color: #382d61;
  color: #fff;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}

.submit-button:hover {
  background-color: #72018f;
}

.selected {
  border: 2px solid #b47db2; /* Example style for selected answer */
}

.no-select {
  user-select: none; /* Standard syntax */
  -webkit-touch-callout: none; /* iOS Safari */
}
  
</style>